export class ContactPointLang {
    public Other: string;
    public Personal: string;
    public Work: string;
}


// WEBPACK FOOTER //
// ./src/resources/ContactPointLang.ts